module.exports = __webpack_public_path__ + "static/media/image-2.6e16eb77.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Ecommerce/image-2.png
// module id = 441
// module chunks = 0